// src/app/meter/components/meter-analytics/meter-alert-type-chart/meter-alert-type-chart.component.ts

import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { AlertsByType } from '../../../models/meter-analytics.model';

@Component({
    selector: 'app-meter-alert-type-chart',
    templateUrl: './meter-alert-type-chart.component.html',
    styleUrls: ['./meter-alert-type-chart.component.scss'],
})
export class MeterAlertTypeChartComponent implements OnChanges {
    @Input() data: AlertsByType[] = [];

    chartData: ChartConfiguration<'doughnut'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'doughnut'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 16 } },
        },
    };

    get total(): number {
        return this.data.reduce((sum, item) => sum + item.count, 0);
    }

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;

        this.chartData = {
            labels: this.data.map((a) => a.alertType),
            datasets: [
                {
                    data: this.data.map((a) => a.count),
                    backgroundColor: ['#ef4444', '#f59e0b', '#06b6d4'],
                    borderWidth: 0,
                },
            ],
        };
    }
}
